import { render, staticRenderFns } from "./wechat-mini.vue?vue&type=template&id=c2e76ba2&"
import script from "./wechat-mini.vue?vue&type=script&lang=js&"
export * from "./wechat-mini.vue?vue&type=script&lang=js&"
import style0 from "./wechat-mini.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports